module.exports = __webpack_public_path__ + "img/user-add.b7343e6f.svg";